import config from '@src/config'
const getApiURL = (lambdaFunc) => {
  const host = window.location.host
  const isLocalhost = host === 'localhost:8000' || host === 'localhost:3000' || host.startsWith('localhost')
  
  // For localhost, use the test API URL
  if (isLocalhost) {
    return config.apiUrl['hosttest.homeworksenergy.com']
  }
  
  // For production, use the configured API URL for the host
  return config.apiUrl[host] || config.apiUrl['host.homeworksenergy.com']
}

export default getApiURL
